import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserModel } from '@models/user.model';
import { SearchCountryField, CountryISO } from '@capgo/ngx-intl-tel-input';
import { UsersFacadeService } from '@services/users/users-facade.service';
import { Subscription } from 'rxjs';
import { AppFacadeService } from '@services/app-facade.service';


@Component({
  selector: 'phone-number-modal-form',
  templateUrl: './phone-number-modal-form.component.html',
  styleUrls: ['./phone-number-modal-form.component.sass']
})
export class PhoneNumberModalFormComponent implements OnInit, OnDestroy {
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Canada, CountryISO.Australia, CountryISO.UnitedKingdom];
  userPhoneForm: FormGroup;
  _subs = new Subscription();
  loggedUser$ = this.appFacadeService.getLoggedUser$();
  loggedUser: UserModel;
  @Output()
  onSave = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private userFacade: UsersFacadeService,
    private appFacadeService: AppFacadeService,
  ) { }

  ngOnInit(): void {
    this.userPhoneForm = this.fb.group({
      phoneNumber: ['', Validators.required],
    });
    this._subs.add(
      this.loggedUser$.subscribe(loggedUser => {
        this.loggedUser = loggedUser
        this.userPhoneForm.patchValue({
          phoneNumber: loggedUser.phoneNumber
        })
      })
    );
  }
  onSaveNumber(form: FormGroup) {
    console.log("this.userPhoneForm.value.phoneNumber ", form.value.phoneNumber);
    this.userPhoneForm.value.phoneNumber = this.userPhoneForm.value.phoneNumber ? this.userPhoneForm.value.phoneNumber.internationalNumber : ''
    this.userFacade.saveUserPhoneNumber({
      userId: this.loggedUser.id,
      phoneNumber: this.userPhoneForm.value.phoneNumber,
      isEnableReviewText: true
    })
    this.onSave.emit()
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }

}
